import { isNullable } from '@app/utils'

import type { FilterFunc } from 'rc-select/lib/Select'
import type { FilterOption } from '@app/types/filter'
import type { DefaultOptionType } from 'antd/es/select'

const getFilteredValues = (values: unknown[], options?: FilterOption[]): unknown[] =>
  values.filter(value => options?.find(option => option.value === value))

export const getFilteredValue = (value: unknown[] | unknown, options?: FilterOption[]): unknown =>
  Array.isArray(value) ? getFilteredValues(value, options) : options?.find(option => option.value === value)?.value

export const filterOptionsByLabel: FilterFunc<DefaultOptionType> = (input, option) =>
  String(option?.label ?? '')
    .toLowerCase()
    .includes(input.toLowerCase())

export const getLabelsByValues = (values: unknown[], options?: FilterOption[]): Array<FilterOption['label']> | null => {
  if (isNullable(options)) return null

  return values.map(value => {
    return options.find(option => option.value === value)?.label
  })
}
